// src/pages/Register.jsx
import React, { useReducer, Fragment, useContext, useState, useEffect } from "react";
import { withCookies } from "react-cookie";
import { Link, useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import { SnackbarContext } from "../context/SnackbarContext";
import { useAPI } from "../context/ApiContext";
import { START_FETCH, FETCH_SUCCESS, ERROR_CATCHED, INPUT_EDIT_REG } from "../components/actionTypes";

const initialState = { isLoading: false, error: "", credentialsReg: { email: "", password: "" } };
const reducer = (s, a) => {
  switch (a.type) {
    case START_FETCH: return { ...s, isLoading: true, error: "" };
    case FETCH_SUCCESS: return { ...s, isLoading: false };
    case ERROR_CATCHED: return { ...s, isLoading: false, error: a.payload || "Registration failed" };
    case INPUT_EDIT_REG: return { ...s, credentialsReg: { ...s.credentialsReg, [a.inputName]: a.payload }, error: "" };
    default: return s;
  }
};

const Register = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { newSnack } = useContext(SnackbarContext);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [showPw, setShowPw] = useState(false);
  const { isAuthenticated, registerWithEmail, loginSocialGeneric } = useAPI();

  useEffect(() => { if (isAuthenticated) history.replace("/home"); }, [isAuthenticated, history]);

  const onChange = (e) => dispatch({ type: INPUT_EDIT_REG, inputName: e.target.name, payload: e.target.value });

  const validate = (email, password) => {
    if (!email) return "Email is required";
    if (!/^\S+@\S+\.\S+$/.test(email)) return t("Register1");
    if (!password || password.length < 6) return t("Register2");
    return "";
  };

  const onRegister = async (e) => {
    e.preventDefault();
    const { email, password } = state.credentialsReg;
    const err = validate(email, password);
    if (err) return dispatch({ type: ERROR_CATCHED, payload: err });
    dispatch({ type: START_FETCH });
    try {
      await registerWithEmail(email.trim(), password);
      dispatch({ type: FETCH_SUCCESS });
      newSnack("success", t("Register3") || "Registered successfully.");
      history.push("/home");
    } catch (e1) {
      if (e1?.status === 404 || e1?.status === 405) {
        try {
          await loginSocialGeneric(email.trim(), "email");
          dispatch({ type: FETCH_SUCCESS });
          newSnack("success", t("Register4") || "Account created. Please set your password later.");
          history.push("/home");
        } catch (e2) {
          dispatch({ type: ERROR_CATCHED, payload: e2?.data?.detail || e2.message });
          newSnack("error", t("Login2"));
        }
      } else {
        dispatch({ type: ERROR_CATCHED, payload: e1?.data?.detail || e1.message });
        newSnack("error", t("Login2"));
      }
    }
  };

  return (
    <Fragment>
      <div className="nl-auth-hero nl-auth-hero--login">
        <div className="nl-auth-hero__bg" aria-hidden="true" />
        <div className="nl-auth-logo">
          <Link to="/home" className="d-flex align-items-center text-decoration-none">
            <img src="/assets/images/nicelinks_icon.png" alt="Nicelinks" />
            <span className="fredoka-font ls-3 fw-600 text-current font-xl ms-1">{t("Login4")}</span>
          </Link>
        </div>

        <div className="nl-pane">
          <h2 className="nl-pane__title text-current" style={{ fontSize: 36 }}>
            {t("Login7")}<br />{t("Login8")}
          </h2>

          <form onSubmit={onRegister} className="p-0">
          <div className="form-group mb-2 nl-input">
              <i className="ti-email" aria-hidden="true" />
              <input
                name="email" type="email" value={state.credentialsReg.email} onChange={onChange}
                className="style2-input form-control text-grey-900 font-xsss fw-600"
                placeholder={t("Login14")} autoComplete="email" required
              />
            </div>
            <div className="form-group mb-3 nl-input">
              <i className="ti-lock" aria-hidden="true" />
              <input
                name="password" type={showPw ? "text" : "password"} value={state.credentialsReg.password}
                onChange={onChange} className="style2-input form-control text-grey-900 font-xss ls-3"
                placeholder={t("Login15")} autoComplete="new-password" required minLength={6}
              />
              <button type="button" className="btn btn-link p-0 font-xssss nl-toggle"
                onClick={() => setShowPw(v => !v)}
                aria-label={showPw ? t("Register6") : t("Register7")}
              >
                {showPw ? t("Register4") : t("Register5")}
              </button>
            </div>

            <button type="submit" className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0 nl-cta"
              disabled={state.isLoading}>
              {t("Login18")}
            </button>
            <h6 className="text-grey-600 font-xssss fw-500 mt-2 mb-0 lh-32">
              {t("Login21")} <Link to="/login" className="fw-700 ms-1">{t("Login13")}</Link>
            </h6>
          </form>

          {state.isLoading && <div className="d-flex justify-content-center mt-3"><CircularProgress size={28} /></div>}
          {state.error && <p className="text-danger mt-2">{state.error}</p>}
        </div>
      </div>
    </Fragment>
  );
};

export default withCookies(Register);
